<template>
    <div >
        <div class="flex jcsb">
            <div>
                <span class="datetxt">姓名:</span>
                <el-select  class="inputwidth" size="mini" @change="nameChange"  filterable remote :remote-method="namesearch"  v-model="leaveper.id">
                    <el-option v-for="(val,index) in searchPeople"  :label="val.name+'('+val.department+')'" :value="val.id"></el-option>
                </el-select>
            </div>
<!--            <div class="right">-->
<!--                <el-button type="primary" :class="baseerp+'btn'"  @click="save" :disabled="disbtn">保存</el-button>-->
<!--                <el-button type="primary" :class="baseerp+'btn'"  @click="close" :disabled="disbtn">取消</el-button>-->
<!--            </div>-->
        </div>
        <new-calender ref="newCalender" :leaveDay="leaveDay" :gongXiu="gongXiu" :btnTxt="btnTxt" :bkbtnTxt="bkbtnTxt" @btnClick="datecli" @dailySituation="dailySituation" @change="collectDate" @fw="getfw" @changeM="getshowForMonth"></new-calender>
        <el-dialog   :title="qjtitle" width="550px" :destroy-on-close="true" @close="closeIn" :close-on-click-modal="false" :show-close="false" v-if="LeaveinEntry"  :visible.sync="LeaveinEntry" append-to-body>
                <jia-bie :leaveper="leaveper" :dateList="dateList" @close="closeIn" @getshowForMonth="getshowForMonth" v-if="dialog=='jiabie'" ></jia-bie>
                <bu-ka :leaveper="leaveper" :dateList="dateList" @close="closeIn" @getshowForMonth="getshowForMonth"  v-if="dialog=='buka'"></bu-ka>
            </el-dialog>
    </div>
</template>

<script>
    import * as API from "../api"
    import NewCalender from "@/components/calender/NewCalender";
    import {baseerp} from "@/utils/baseUrl";
    import {mapActions} from "vuex";
    import JiaBie from "./JiaBie";
    import BuKa from "./BuKa";

    function getDate(date, AddDayCount = 0) {
        if (!date) {
            date = new Date()
        }
        if (typeof date !== 'object') {
            date = date.replace(/-/g, '/')
        }
        const dd = new Date(date)
        dd.setDate(dd.getDate() + AddDayCount) // 获取AddDayCount天后的日期

        const y = dd.getFullYear()
        const m = dd.getMonth() + 1 < 10 ? '0' + (dd.getMonth() + 1) : dd.getMonth() + 1 // 获取当前月份的日期，不足10补0
        const d = dd.getDate() < 10 ? '0' + dd.getDate() : dd.getDate() // 获取当前几号，不足10补0
        return {
            fullDate: y + '-' + m + '-' + d,
            year: y,
            month: m,
            date: d,
            day: dd.getDay()
        }
    }
    export default {
        name: "AttendEntry",
        props:{
            leaveData:{
                type:Object,
                required:true
            }
        },
        components:{JiaBie, NewCalender,BuKa},
        data(){
            /**
             * 获取当天时间
             * @returns {string}
             */
            function getCurDay(num = 0) {
                let datetime = new Date();
                let year = datetime.getFullYear();
                let month = datetime.getMonth() + 1 < 10 ? "0" + (datetime.getMonth() + 1) : datetime.getMonth() + 1;
                let day = datetime.getDate()
                if ((day + num) > 0) {
                    day = (day + num) < 10 ? "0" + (datetime.getDate() + num) : datetime.getDate() + num;
                } else {
                    day = (day - num) < 10 ? "0" + (datetime.getDate() - num) : datetime.getDate() - num;
                }
                return `${year}-${month}-${day}`
            }
            return{

                baseerp:'',
                btnTxt: '去请假',
                bkbtnTxt:'去补卡',
                leaveDay: [],
                gongXiu: [],
                newdate: {},
                monthValue:'',
                pointMap: {[new Date(getCurDay()).getTime()]: true},
                restrictDate:{},
                LeaveinEntry: false,
                dialog:'',
                defaultValue:'',
                pickerOptions:{
                },
                search:'',
                searchPeople:[],
                datedifferent:0,
                disbtn:false,
                i_id:0,
                leaveper:{},
                sub:[],
                filesList:[],
                dateList:[],
                qjtitle:'',
                kqtc:{},
            }
        },
        mounted(){
            this.baseerp=baseerp
            this.$nextTick(()=>{
                if (this.leaveData.personId!==''){
                    this.searchname=this.leaveData.personName}else {this.searchname=''}
                this.leaveper.type=this.leaveData.type
                // this.leaveper.isrepair=this.leaveData.isrepair
                this.searchUser()
            })
        },
        methods:{
            getMonth(type, year, month) {
                //getMonth(type,year,months)  //type为字符串类型，有两种选择，"s"代表开始,"e"代表结束
                //getMonth("s",2020,5)  //得到该月第一天的yyyy-mm-dd格式日期
                //getMonth("e",2020,5)  //得到该月最后一天的yyyy-mm-dd格式日期
                // month = month < 10 ? "0" + month : month;
                let firstday = year + "-" + month + "-" + "01";
                let lastday = "";
                if (month == "01" || month == "03" || month == "05" || month == "07" || month == "08" || month == "10" ||
                    month == "12") {
                    lastday = year + "-" + month + "-" + 31;
                } else if (month == "02") {
                    if ((year % 4 == 0 && year % 100 != 0) || (year % 100 == 0 && year % 400 == 0)) {
                        lastday = year + "-" + month + "-" + 29;
                    } else {
                        lastday = year + "-" + month + "-" + 28;
                    };
                } else {
                    lastday = year + "-" + month + "-" + 30;
                };
                var day = "";
                if (type == "s") {
                    day = firstday;
                } else {
                    day = lastday;
                };
                return day;
            },
            async getshowForMonth(){
                if (this.leaveper.id ){
                    let params = {
                        userId: this.leaveper.id ,
                        startDate: this.dateFw.start,
                        endDate: this.dateFw.end,
                    }
                    let res = await API.getshowForMonth(params)
                    if(res.code == 1){
                        let data2=[];
                        res.data.list.map((value,index,arry)=>{
                            data2.push({ 'date': value.forDate, 'leave': value.showNote,'isrepair':value.isrepair,'i_edit':value.i_edit })
                        })
                        this.leaveDay = data2
                    }
                }

            },
            convertKey (arr, key) {
                let newArr = [];
                arr.forEach((item, index) => {
                    let newObj = {};
                    for (let i = 0; i < key.length; i++) {
                        newObj[key[i]] = item[Object.keys(item)[i]]
                    }
                    newArr.push(newObj);
                })
                // console.log(newArr)
                return newArr;
            },
            collectDate(list,shift){
                this.btnTxt='去请假';
                this.dateList = list;
                this.leaveper.type='new';
                this.leaveper.shift=shift;
                let arr=this.dateList.filter(x=>this.leaveDay.some(y=>x==y.date&&y.i_edit==1));
                let bkarr=this.dateList.filter(x=>this.leaveDay.some(y=>x==y.date&&(y.leave.includes('退')||y.leave.includes('迟')||y.leave.includes('未'))));

                // let bkarr=this.dateList.filter(x=>this.leaveDay.some(y=>x==y.date&&y.isrepair==1));
                if(arr.length==1&&this.dateList.length==1){
                    this.btnTxt='去编辑';
                    // this.bkbtnTxt='';
                    this.leaveper.type='calender';
                }
                if(arr.length==0&&bkarr.length!==0||arr.length>1){  this.btnTxt='';  }
                if(bkarr.length==0){  this.bkbtnTxt=''; }
                // if (arr.length==1&&this.dateList.length==1){
                if (bkarr.length&&this.dateList.length){
                    this.bkbtnTxt='去补卡';
                    this.leaveper.type='calender';
                }
            },
            getfw(fw){
                this.dateFw=fw
            },
            datecli(type){
                if (this.leaveper.id==undefined){
                    this.$message.error('请选择要操作的人员');
                    return;
                }
                let arr=this.dateList.filter(x=>this.leaveDay.some(y=>x==y.date&&y.i_edit==1));
                // let bkarr=this.dateList.filter(x=>this.leaveDay.some(y=>x==y.date&&y.isrepair==1));
                let bkarr=this.dateList.filter(x=>this.leaveDay.some(y=>x==y.date&&(y.leave.includes('退')||y.leave.includes('迟')||y.leave.includes('未'))));

                if(arr.length>0&&this.dateList.length>1){
                    this.$message.warning('请不要选择已有假别的日期');
                    this.$refs.newCalender.clearData();
                    this.dateList=[];
                    this.$forceUpdate();
                    return;
                }
                // if(bkarr.length>0&&this.dateList.length>1){
                //     this.$message.warning('只能选择某一天进行补卡');
                //     this.$refs.newCalender.clearData();
                //     this.dateList=[];
                //     this.$forceUpdate();
                //     return;
                // }
                if (this.dateList.length&&bkarr.length){
                    this.btnTxt='';
                    this.bkbtnTxt='去补卡';
                    this.leaveper.type='calender';
                }
                if (this.dateList.length==1&&this.leaveDay.some(y=>this.dateList[0]==y.date&&(y.i_edit==1))){
                    this.btnTxt='去编辑';
                    this.bkbtnTxt='';
                    this.leaveper.type='calender';

                }
                if(arr.length==0){  this.btnTxt='';  }
                if(bkarr.length==0){  this.bkbtnTxt=''; }
                this.LeaveinEntry=true;
                if(type=='jiabie'){
                  this.dialog='jiabie'
                }else if(type=='buka'){
                    this.dialog='buka'
                }
            },
            ...mapActions(["getCurrentMenuId"]),

            async getuserInfo(){
              let param = {
                  userId: this.leaveper.id,
              }
              let res = await API.getuserInfo(param);
              if(res.code == 1){
                  this.leaveper.unit = res.data.unit;
                  this.leaveper.dt_upperstart=res.data.dt_upperstart;
                  this.leaveper.dt_upperend=res.data.dt_upperend;
                  this.leaveper.dt_lowerstart=res.data.dt_lowerstart;
                  this.leaveper.dt_lowerend=res.data.dt_lowerend;
                  this.kqtc.kqtcid=res.data.kqtcid;
                  this.kqtc.djmark=res.data.djmark;
                  this.leaveper.djmark=res.data.djmark;
                  this.leaveper.kqtc=res.data.kqtc;
                  this.leaveper.ispb=res.data.ispb;
                  this.dailySituation()
              }  else if(res.code == 0) {
                  this.$message.error(res.message);
              }
            },
            async dailySituation(){
                if(this.kqtc.kqtcid){
                    let param = {
                        startDate:this.dateFw.start,
                        endDate:this.dateFw.end,
                        djmark:this.kqtc.djmark,
                        kqtcId:this.kqtc.kqtcid

                    };
                    let res = await API.dailySituation(param);
                    if (res.code == 1) {
                        this.gongXiu=res.data
                    } else if (res.code == -2) {
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        this.$message.error(res.message);
                    }
                }
            },
            Disabledate(){
                let now = new Date(this.dateMonth)//当前日期
                // now.getFullYear() -- 当前年  now.getMonth() -- 当前月
                let monthEndDate = new Date(now.getFullYear(), now.getMonth(), 1) // 获取本月的开始日期
                // let date=new Date()
                let timeEnd = Date.parse(monthEndDate)
                // 设置某段日期的禁用状态
                this.pickerOptions.disabledDate = time => (time.getTime() < timeEnd)
                // (time.getTime() > timeEnd + 60 * 60 * 24 * 1000)
            },

            //延迟搜索
            namesearch(val){
                this.searchname=val
                this.searchUser()
            },
            //名称搜索
            nameChange(val){
                this.leaveper.id=val
                let obj=this.searchPeople.find(one=>one.id==val);
                this.leaveper.name=obj.name;
                this.qjtitle=`${obj.name}(${obj.department})`;
                // console.log(obj,'val')
                this.getuserInfo()
                this.getshowForMonth()
                this.$forceUpdate()
            },

            close(){
                // console.log('this.offsetovertimethis.offsetovertime')
                // // return
                // this.$emit('close')
                // this.$emit('applicationList')

            },
            closeIn(){
                // console.log('closeIn')
                this.LeaveinEntry = false
                this.dialog=''
                this.$refs.newCalender.btnup()
                this.dateList=[]
                this.btnTxt=''
                this.bkbtnTxt=''
            },
            //搜索查询
            async searchUser() {
                let params = {
                    keyname:this.searchname
                }
                let res = await API.searchUser(params);
                if (res.code == 1) {
                    this.searchPeople=res.data
                    if (this.leaveData.personId!==''&&this.searchPeople.length==1){
                        this.leaveper.id= this.searchPeople[0].id
                        this.leaveper.name=this.searchPeople[0].name;
                        this.leaveData.personId=''
                        this.getuserInfo()
                        this.getshowForMonth()
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            close(){},
        }
    }
</script>

<style lang="scss" scoped>
    .center{
        text-align: center;
    }
    .right{
        text-align: right;
    }
    .flex{
        display: flex;
    }
    .jcsb{
        justify-content: space-between;
    }
.inputwidth{
    width:280px;
}
.dateinput{
    width:280px;
}
.datebox{
    margin-bottom: 20px ;
}
.datetxt{
    padding-right: 10px;
    display: inline-block;
    min-width: 70px;
}
/deep/{
    .el-calendar__body{
        padding: 12px 20px;
        height: unset;
    }
}
</style>